import { render, staticRenderFns } from "./suggestReadCard.vue?vue&type=template&id=4a4c5896&scoped=true"
import script from "./suggestReadCard.vue?vue&type=script&lang=js"
export * from "./suggestReadCard.vue?vue&type=script&lang=js"
import style0 from "./suggestReadCard.vue?vue&type=style&index=0&id=4a4c5896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c5896",
  null
  
)

export default component.exports